import React from "react";
import ReactPaginate from "react-paginate";
import Loading from "../../../components/loading";

export default function ListVendorCategory({
    loading,
    filteredVendorCategories,
    selected,
    handleSelect,
    handleToggleStatus,
    pageCount,
    handlePageClick,
}) {
    return (
        <div className="table-responsive">
            <table className="table table-striped table-bordered">
                <thead className="table-light">
                    <tr>
                        <th>Select</th>
                        <th>Vendor Category Name</th>
                        <th>Vendor Category Code</th>
                        <th>Status</th>
                    </tr>
                </thead>

                <tbody>
                    {loading ? (
                        <tr>
                            <td colSpan="4" className="text-center py-4">
                                <Loading />
                            </td>
                        </tr>
                    ) : filteredVendorCategories.length > 0 ? (
                        filteredVendorCategories.map((v) => {
                            const isActive = v.status === "Active";
                            return (
                                <tr key={v.id}>
                                    <td>
                                        <input
                                            type="radio"
                                            name="vendorCategorySelect"
                                            disabled={v.status === "InActive"}
                                            checked={selected === v.id}
                                            onChange={() => handleSelect(v.id)}
                                        />
                                    </td>
                                    <td>{v.vendorCategoryName}</td>
                                    <td>{v.vendorCategoryCode}</td>
                                    <td>
                                        <span
                                            className={`badge ${isActive ? "bg-success" : "bg-secondary"
                                                }`}
                                            style={{ cursor: "pointer" }}
                                            onClick={() => handleToggleStatus(v)}
                                        >
                                            {v.status}
                                        </span>
                                    </td>
                                </tr>
                            );
                        })
                    ) : (
                        <tr>
                            <td colSpan="4" className="text-center text-muted">
                                No vendor categories found.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>

            <ReactPaginate
                breakLabel="..."
                nextLabel="Next >"
                onPageChange={handlePageClick}
                pageRangeDisplayed={3}
                marginPagesDisplayed={2}
                pageCount={pageCount}
                previousLabel="< Previous"
                containerClassName="pagination-container"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                activeClassName="active"
            />
        </div>
    );
}
